import React, { useContext } from 'react';
import { MYSAFETY_IMAGE, NEW } from '../../constants/miscellaneousConstants';
import { CabData } from '../../pages/runtime-typechecker';
import {
  formatText,
  getCarTypeForDisplay,
  getColorGradientClassByRating
} from '../../utils/stringUtils';
import '../RouteCabsV2/RouteCabsV2Mobile.css';
import { Context } from '../../AppContext';
export const RouteCabsV2Mobile = ({
  data,
  redirect
}: {
  data: CabData[] | null | undefined;
  redirect: (url: string | null | undefined) => void;
}) => {
  const { trackTemplateEvent } = useContext(Context);
  return (
    <table
      style={{
        borderSpacing: '0px 15px',
        width: '100%',
        border: '1px solid #cecece'
      }}
      className=" fullWidth noBorder "
    >
      <tbody className=" fullWidth ">
        {data &&
          data.map((cabInfo, idx) => {
            const {
              mobile_persuasions,
              cab_description,
              cab_description_v2,
              cab_description_mweb,
              strike_off_discount_textV2,
              total_amount,

              my_safety,
              reviewURL,
              model_name,
              model_description,
              image_url
            } = cabInfo;
            return (
              <tr className=" fullWidth ">
                <td
                  onClick={() => {
                    trackTemplateEvent(
                      `Cab_SEO_Route_${cabInfo.type}_Book_Isomorph_Cab_Click`
                    );
                    redirect(reviewURL);
                  }}
                >
                  <div
                    style={{
                      border:'1px solid #cecece',
                      borderRadius:'8px',
                      backgroundColor: '#ffffff',
                      boxShadow: '0 4px 8px 0 rgba(138, 107, 118, 0.08)',
                      display: 'block',
                      borderColor: 'rgb(216, 216, 216)',
                    }}
                    className="cabCardMobile fullWidth "
                  >
                    <div className="fullWidth makeFlex">
                      <div
                        className={`appendRight10 cabCardImageContainer ${
                          idx > 1 ? 'lazyload' : ''
                        }`}
                      >
                        <img
                          width={62}
                          height={47}
                          src={image_url || ''}
                          data-src={image_url || ''}
                        />
                      </div>
                      <div>
                        <div className="blackText latoItalic font11 appendBottom5">
                          {model_description}
                        </div>
                        <div className="latoBlack font16 blackText appendBottom10">
                          {model_name}
                        </div>
                        <div
                          style={{ flexWrap: 'wrap' }}
                          className="blackText latoRegular font11 makeFlex"
                        >
                          <span>
                            {getCarTypeForDisplay(cabInfo.type || '')}
                            &nbsp;&nbsp;&nbsp;
                          </span>
                          <span className="circleBulletBlack appendRight5 vertlCenter makeFlex"></span>
                          <span>AC&nbsp;&nbsp;&nbsp;</span>
                          <span className="circleBulletBlack appendRight5 vertlCenter makeFlex"></span>
                          <span style={{ whiteSpace: 'nowrap' }}>
                            {(() => {
                              if (cabInfo?.seat_count)
                                return `${cabInfo.seat_count} Seats`;
                            })()}
                          </span>
                        </div>
                      </div>
                      {my_safety ? (
                        <div
                          style={{ height: 15 }}
                          className="makeFlex pushRight"
                        >
                          <span className="appendRight2 makeFlex">
                            <img
                              height={15}
                              width={15}
                              className=""
                              src={MYSAFETY_IMAGE}
                            ></img>
                          </span>
                          <span
                            style={{
                              borderWidth: 0.5,
                              borderStyle: 'dotted',
                              borderColor: 'rgb(216, 216, 216)',
                              padding: 2
                            }}
                            className="makeFlex vertlCenter"
                          >
                            <span className="latoBlack deepskyBlueText font10 ">
                              My
                            </span>
                            <span className="latoBlack blackText font10 ">
                              Safety
                            </span>
                          </span>
                        </div>
                      ) : null}{' '}
                    </div>
                    <div
                      style={{ width: '90%' }}
                      className="dottedHorizontalLine appendTop10 appendBottom10"
                    ></div>
                    <div className="makeFlex appendBottom10">
                      <div style={{ width: '60%' }} className="makeBlock">
                        {cabInfo.overall_rating && cabInfo.rating_show ? (
                          <span
                            style={{
                              marginRight: '5px',
                              display: 'inline-flex'
                            }}
                            className={`${getColorGradientClassByRating(
                              Number(cabInfo.overall_rating)
                            )} ratingBoxV2 paddingL2 paddingR4 appendRight5`}
                          >
                            <span
                              className={`latoBlack whiteText lineHeight18 font10`}
                            >
                              {cabInfo.overall_rating}/
                            </span>
                            <span className={`whiteText lineHeight18 font10`}>
                              5
                            </span>
                          </span>
                        ) : (
                          <span
                            style={{ marginRight: '5px' }}
                            className={`ratingBox paddingT2 paddingB2 whiteText paddingL2 paddingR4 appendRight5 font10 latoBlack`}
                          >
                            {NEW}
                          </span>
                        )}
                        <div className="appendTop5 appendBottom10">
                          <span className="font12 latoBlack blackText">
                            {cab_description_mweb
                              ? cab_description_mweb
                              : cab_description}
                          </span>
                        </div>
                      </div>
                      <div className="pushRight">
                        <div className="pushRight">
                          <div
                            className={`latoItalic pushRightBottom redText pushRight font12 appendBottom2`}
                          >
                            <span>{strike_off_discount_textV2}</span>
                          </div>
                          <div className={`pushRightBottom pushRight`}>
                            <span
                              className={`strikeDiagonal font12 lightGreyText latoRegular appendRight5 appendTop5`}
                            >
                              {cabInfo.strike_off_amount
                                ? `₹ ${cabInfo.strike_off_amount}`
                                : ``}
                            </span>
                            <span
                              className={`cabsV2TypePrice blackText appendBottom2`}
                            >
                              {total_amount ? `₹ ${total_amount}` : ``}
                            </span>
                          </div>
                          <div>
                            {cabInfo?.tolls_and_taxes_text ? (
                              <p
                                className={`font10 latoRegular lightGreyText pushRightBottom appendBottom5 `}
                              >
                                {cabInfo?.tolls_and_taxes_text}
                              </p>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="makeFlex">
                      <div>
                        {' '}
                        {mobile_persuasions &&
                          mobile_persuasions.map((persuasion, idx) => {
                            const {
                              title,
                              icon_url,
                              text,
                              highlighted_text,
                              highlight_color,
                              tag_icon_url,
                              tooltip_icon
                            } = persuasion;
                            return (
                              <div
                                key={`persuasion_${idx}`}
                                style={{ display: 'flex' }}
                                className="makeFlex paddingT5 paddingB5 makeFlex vertlCenter"
                              >
                                <div>
                                  {icon_url || tag_icon_url ? (
                                    <img
                                      className={`appendRight10 height14`}
                                      alt={`pers`}
                                      height={14}
                                      width={14}
                                      src={icon_url || tag_icon_url || ''}
                                    ></img>
                                  ) : null}
                                </div>
                                <div
                                  style={{
                                    display: 'flex',
                                    marginRight: '5px'
                                  }}
                                  className="makeFlex fullWidth"
                                >
                                  <div
                                    style={{ marginRight: '5px' }}
                                    className="font11 latoBold blackText cabCardInfoPersuasionTitle vertlCenter"
                                  >
                                    {title}
                                  </div>
                                  <div>
                                    {formatText({
                                      text,
                                      classNameForToolTipIcon:
                                        'appendLeft5 toolTipIcon font11',
                                      highlightedText: highlighted_text,
                                      highlightedColor: highlight_color,
                                      classNameForNonHighightedText:
                                        'blackText font11',
                                      className: 'latoBold blackText  font11',
                                      tooltipIcon: tooltip_icon,
                                      idx: idx
                                    }).map(val => val)}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};
